import { ViewModel,View } from "binder"
import { FormBuilderComponent } from "src/formBuilder/structure/components";
import { ChildAcceptableFormBuilderElement, FormBuilderElement, IFormBuilderElementVisitor } from "src/formBuilder/structure/element";
import { ContentPropertyType } from "src/formBuilder/structure/propertyTypes/propetyTypes";
import  { HrView } from "./hr-view"


export class HrComponent extends FormBuilderComponent{
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
        this.name = 'Horizontal Line';
        this.canAcceptContent = true;
        this.canAcceptMultipleContent = false;

        this.addProperty("Content","",new ContentPropertyType(this),null,true);
    }
    public getTypeId(): string {return '';}
    public GetDefaultView(): View<ViewModel> {return null;}

    CreateInternal(parent:ViewModel):FormBuilderElement{
        let result = new HrViewModel(parent);
        return result;
    }
        
}


export class HrViewModel extends ChildAcceptableFormBuilderElement{
    
    constructor(parentViewModel: ViewModel) {
        super(parentViewModel);
    }
    GetDefaultView(): View <ViewModel> {
        return new HrView();
    }
    public getTypeId(): string {
        return "VM-2BCEB566-049B-40B5-B489-7DA3B89F7F5F"
    }
    public set Content(v: FormBuilderElement) { this._Content = v; } public get Content(): FormBuilderElement { return this._Content;} private _Content: FormBuilderElement;

    Accept(visitor: IFormBuilderElementVisitor, parameter: object): object {
        return visitor.VisitHr(this,parameter);
    }
    addChildInternal(element: FormBuilderElement): void {
        this.children.update(...[element]);
        this.Content = element;
    }
    removeChild(element: FormBuilderElement): void {
        if(element && this.Content &&this.Content.self == element.self){
            this.children.clear();
            this.Content = null;
        }
    }
}
